import React from 'react';

const DividerSquiggle = ({ color }) => {
  return (
    <svg
      width="338"
      height="20"
      viewBox="0 0 338 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M6 6.20173C8.70522 0.599423 16.8209 0.599423 18.5385 6.20173C20.0823 11.2374 29.1446 11.2947 31.0769 6.20173C33.7821 0.599423 41.8978 0.599423 43.6154 6.20173C45.1592 11.2374 54.2215 11.2947 56.1538 6.20173C58.8591 0.599423 66.9747 0.599423 68.6923 6.20173C70.2362 11.2374 79.2985 11.2947 81.2308 6.20173C83.936 0.599423 92.0516 0.599423 93.7692 6.20173C95.3131 11.2374 104.375 11.2947 106.308 6.20173C109.013 0.599423 117.129 0.599423 118.846 6.20173C120.39 11.2374 129.452 11.2947 131.385 6.20173C134.09 0.599423 142.205 0.599423 143.923 6.20173C145.467 11.2374 154.529 11.2947 156.462 6.20173C159.167 0.599423 167.282 0.599423 169 6.20173C170.544 11.2374 179.606 11.2947 181.538 6.20173C184.244 0.599423 192.359 0.599423 194.077 6.20173C195.621 11.2374 204.683 11.2947 206.615 6.20173C209.321 0.599423 217.436 0.599423 219.154 6.20173C220.698 11.2374 229.76 11.2947 231.692 6.20173C234.398 0.599423 242.513 0.599423 244.231 6.20173C245.775 11.2374 254.837 11.2947 256.769 6.20173C259.474 0.599423 267.59 0.599423 269.308 6.20173C270.852 11.2374 279.914 11.2947 281.846 6.20173C284.551 0.599423 292.667 0.599423 294.385 6.20173C295.928 11.2374 304.991 11.2947 306.923 6.20173C309.628 0.599423 317.744 0.599423 319.462 6.20173C321.005 11.2374 330.068 11.2947 332 6.20173"
          stroke={color}
          strokeOpacity="0.7"
          strokeWidth="3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.649231"
          y="0.5"
          width="336.753"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default DividerSquiggle;
